// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"DT","fixed":"ET","nonLayerdFacets":"FT","productCount":"GT","facetBack":"HT","arrow":"IT"};